import { HrisIntegrationTypeState } from './hris-integration-type-selectors';
import { FAILURE, STARTING, SUCCESS } from '../action/util/action-name-creators';
import { Action, StateStatus } from '../reducers/utils/state-manager';

const InitialState = {
  hrisIntegrationTypes: [],
  hrisIntegrationTypesState: StateStatus.notAttempted,
};

export const hrisIntegrationTypesReducer = (
  state: HrisIntegrationTypeState = InitialState,
  action: Action,
) => {
  switch (action.type) {
    case STARTING('LOAD_HRIS_INTEGRATION_TYPES'): {
      return {
        ...state,
        hrisIntegrationTypesState: StateStatus.loading,
      };
    }
    case SUCCESS('LOAD_HRIS_INTEGRATION_TYPES'): {
      const {
        payload: { data },
      } = action;
      return {
        ...state,
        hrisIntegrationTypes: data,
        hrisIntegrationTypesState: StateStatus.success,
      };
    }
    case FAILURE('LOAD_HRIS_INTEGRATION_TYPES'): {
      return {
        ...state,
        hrisIntegrationTypesState: StateStatus.error,
      };
    }
    default:
      return state;
  }
};
